export const themeStorageKey = 'PORTAL_THEME';
export const darkMediaQuery = '(prefers-color-scheme: dark)';
